import { IKendoCapsuleData } from "../../typings/board/Models";
import * as moment from "moment";

export class KendoGridCapsuleFolder implements IKendoCapsuleData {
    public fileFolderName : string;
    public fileFolderSize : number;
    public extension : string;
    public filefolderLastModifiedDate : string;
    public isFolder : boolean;

    constructor(name: string, extension: string, size: number, lastModifiedDate: string, isFolder : boolean) {
        this.filefolderLastModifiedDate = lastModifiedDate;
        this.extension = extension;
        this.fileFolderName = name;
        this.fileFolderSize = size;
        this.isFolder = isFolder;
    }
}


// WEBPACK FOOTER //
// ./app/hierarchy-support/KendoGridCapsuleFolder.ts